import { AxiosError } from 'axios';
import React from 'react';
import Banner from '@cpg-its/ads.containers.banner';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../root/tcsm-model';
import { TcsmSiteSettingsProps } from '../models/epi-model';
import { ContentSpacer } from './layout/generic-content-spacer';

interface Props {
    generalErrorMessage?: string;
}

export const GlobalErrorMessage = (props: Props) => {
    const { generalErrorMessage } = props;

    const errors = useSelector<TcsmStates, AxiosError[]>(state => state.apiState.error)?.filter(a => a?.config?.method !== 'get' || a?.config?.url?.includes('terminations/'));
    const errorSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state.epiProps.siteSettingsState.siteSettings);

    const getErrorMessage = (error: AxiosError) => {

        // use the general error message when provided
        if (generalErrorMessage) return [props.generalErrorMessage];

        const message = (error?.response?.data?.status?.message as string);

        if (message) return [message];

        const type = error.response ? error.response.status : error.code;
        switch (type) {
            case 400:
                return [errorSettings.error400];
            case 404:
                return [errorSettings.error404];
            case 500:
                return [errorSettings.error500];
            case 'ECONNABORTED':
                return [errorSettings.errorTimeout];
            default:
                return [errorSettings.defaultError];
        }
    };

    const errorMapped = (a: AxiosError) => {
        const parsedError = getErrorMessage(a);
        return parsedError?.join(', ');
    };

    return (
        errors && errors.length > 0 ? (
            <ContentSpacer>
                <Banner
                    banner={{
                        type: 'error',
                        label: 
                        <div className='rich-text'>
                            <div dangerouslySetInnerHTML={{ __html: `<strong> ${ errors?.map(a => { return errorMapped(a); }).join(', ')} </strong>` }} 
                                className='rich-text'                                            
                                aria-label='cms-content'
                                role='link' 
                            />                            
                        </div>,
                    }}
                />

            </ContentSpacer>
        )
            : null
    );
};

GlobalErrorMessage.defaultProps = {
    generalErrorMessage: '',
};

